import { addTreeNodeChild } from '../../utils/tree.js';
import { removeFixtureNameExtension } from '../fixtureUtils.js';
export function createRawFixtureTree(fixtures) {
    const rootNode = {
        data: { type: 'fileDir' },
    };
    Object.keys(fixtures).forEach(fixturePath => addFixturePathToTree(rootNode, fixturePath, fixtures[fixturePath]));
    return rootNode;
}
function addFixturePathToTree(rootNode, fixturePath, fixtureItem) {
    const { parents, fileName } = parseFixturePath(fixturePath);
    if (fixtureItem.type == 'single') {
        injectNode(rootNode, parents, fileName, {
            data: {
                type: 'fixture',
                path: fixturePath,
            },
        });
    }
    else if (fixtureItem.type == 'multi') {
        injectNode(rootNode, parents, fileName, {
            data: {
                type: 'multiFixture',
                path: fixturePath,
                names: fixtureItem.fixtureNames,
            },
        });
    }
}
function parseFixturePath(fixturePath) {
    const parents = fixturePath.split('/');
    const rawFixtureName = parents.pop();
    if (!rawFixtureName)
        throw new Error('Fixture name is empty');
    return {
        parents,
        fileName: removeFixtureNameExtension(rawFixtureName),
    };
}
function injectNode(rootNode, parents, childName, childNode) {
    if (parents.length === 0)
        return addTreeNodeChild(rootNode, childName, childNode);
    let curNode = rootNode;
    for (const dirName of parents) {
        if (!curNode.children)
            curNode.children = {};
        if (!curNode.children[dirName]) {
            curNode.children[dirName] = { data: { type: 'fileDir' } };
        }
        curNode = curNode.children[dirName];
    }
    addTreeNodeChild(curNode, childName, childNode);
}
